import {
  ChakraFlex,
  ChakraGridItem,
  ChakraText,
  EquipUITheme,
  NumberInput,
} from '@equip.health/ui';

import { GridItemProps } from '~/components/maud/patients/profile/clinical-profile/clinical-measurement/clinical-measurement-modal/constants';

const { paragraphBold } = EquipUITheme.typography;

const MultiValueGridItem = ({
  colSpan,
  id,
  isEditing,
  onChange,
  unit,
  value,
}: GridItemProps<string[]> & { unit: string; value: string[] }) => (
  <ChakraGridItem colSpan={colSpan}>
    {unit && (
      <ChakraFlex align="center" gridRowGap="2px" id={`${id}__flex`}>
        {isEditing && (
          <ChakraFlex
            align="center"
            gridRowGap="2px"
            justifyContent="space-between"
          >
            <NumberInput
              color="neutral.primary"
              height="32px"
              id={`${id}__input-1`}
              inputPadding="0px 12px"
              maxLength={3}
              min={0}
              onChange={(newVal) => {
                onChange([newVal, value[1]]);
              }}
              size="sm"
              // pre-existing pattern is to pass a string to NumberInput, despite its types requesting number
              // without string values, typing decimal values is impossible because the decimal gets erased
              // ex. typing "10.5" will erase the decimal when typing 10. because 10. simplifies to the number 10
              value={value[0] as unknown as number}
            />
            <ChakraText
              {...paragraphBold}
              id={`${id}__value-display`}
              lineHeight="120%"
            >
              /
            </ChakraText>
            <NumberInput
              color="neutral.primary"
              height="32px"
              id={`${id}__input-2`}
              inputPadding="0px 12px"
              maxLength={3}
              min={0}
              onChange={(newVal) => {
                onChange([value[0], newVal]);
              }}
              size="sm"
              value={value[1] as unknown as number}
            />
          </ChakraFlex>
        )}
        <ChakraText
          {...paragraphBold}
          id={`${id}__value-display`}
          lineHeight="120%"
        >
          {isEditing ? '' : `${value[0]} / ${value[1]}`}&nbsp;{unit}
        </ChakraText>
      </ChakraFlex>
    )}
  </ChakraGridItem>
);

export default MultiValueGridItem;
